import React from 'react';
import {
  ListItem,
  ListItemIcon,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { FortressLogo } from '@fortress-technology-solutions/fortress-component-library/Icons';

const FortressLogoListItem = ({ children }) => (
  <ListItem
    sx={{
      height: 70,
      paddingLeft: '12px',
      paddingTop: '4px',
      paddingBottom: 2,
    }}
  >
    <ListItemIcon sx={{ minWidth: 'unset', marginRight: 1 }}>
      <FortressLogo sx={{ fontSize: '20px' }} />
    </ListItemIcon>
    {children}
  </ListItem>
);

export default FortressLogoListItem;
